import { createSelector } from 'reselect';
import { sample, get, compose, take, mapValues, groupBy } from 'lodash/fp';

// create a pool of players to randomly select between.
// It's more important that this pool is small rather than accurate as
// we want our autofill animation to run at 60fps.
function getPlayersAndTeams(players, teams) {
  return compose(
    mapValues(arr => take(15)(arr)), // cap at 15 to make the sample function fast
    groupBy(entity =>
      compose(
        get('key'),
        sample
      )(entity.positions)
    )
  )([...Object.values(players), ...Object.values(teams)]);
}

const randomLineUpPoolSelector = createSelector(
  get('challenge.players'),
  get('challenge.teams'),
  getPlayersAndTeams
);

export default randomLineUpPoolSelector;
